import { createReducer, on } from '@ngrx/store';
import { saveToken, removeToken } from '../actions/token.actions';

export interface TokenState {
  token: string | null;
}

export const initialState: TokenState = {
  token: null,
};

export const tokenReducer = createReducer(
  initialState,

  on(saveToken, (state, { token }) => ({
    ...state,
    token,
  })),

  on(removeToken, () => ({
    token: null,
  }))
);
